const Placeholder = () => {
    return (
        <div>
            <h1>Something will be here later.</h1>
        </div>
    );
}

export default Placeholder;